import o from "./highrise1410.mjs";
import r from "./highrise1521.mjs";
import i from "./highrise647.mjs";
var u = r ? function(t, e) {
  return r(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: o(e),
    writable: !0
  });
} : i;
export {
  u as default
};
